import { c as _c } from "react/compiler-runtime";
import React, { memo } from 'react';
import classNames from 'classnames';
import MaterialThumbnailPlaceholder from '../MaterialThumbnail/MaterialThumbnailPlaceholder';
const MaterialThumbnailGroupPlaceholder = t0 => {
  const $ = _c(15);
  const {
    className,
    variant
  } = t0;
  const t1 = `relative w-full ${className}`;
  const t2 = variant === "PDPSelectUpholsteryUI" || variant === "PDPSelectUpholsteryUI--quickview";
  const t3 = variant === "PDPSelectUpholsteryUI--quickview";
  let t4;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3) {
    t4 = classNames(t1, {
      "max-[1023px]:[-ms-overflow-style:none] max-[1023px]:overflow-x-scroll max-[1023px]:overflow-y-hidden max-[1023px]:pl-5 max-[1023px]:relative max-[1023px]:[scrollbar-width:none] max-[1023px]:w-screen lg:max-[1023px]:h-[45px] max-[1023px]:md:pl-[3.333vw] [&::-webkit-scrollbar]:max-[1023px]:hidden": t2,
      "max-[1023px]:md:h-auto max-[1023px]:md:overflow-auto max-[1023px]:md:!p-0 max-[1023px]:md:w-auto": t3
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = variant === "PDPSelectUpholsteryUI--quickview";
  let t6;
  if ($[4] !== t5) {
    t6 = classNames("max-[1023px]:flex max-[1023px]:max-w-full lg:grid lg:grid-cols-[repeat(auto-fill,minmax(49px,1fr))] lg:relative lg:z-0", {
      "max-[1023px]:md:grid max-[1023px]:md:grid-cols-[repeat(auto-fill,minmax(49px,1fr))] max-[1023px]:md:relative max-[1023px]:md:z-0": t5
    });
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== variant) {
    t8 = t7.map(id => <div className={classNames("h-full w-full max-[1023px]:flex-shrink-0 max-[1023px]:h-[59px] max-[1023px]:min-w-[59px] max-[1023px]:w-[59px]", {
      "max-[1023px]:md:h-full max-[1023px]:md:min-w-[auto] max-[1023px]:md:w-full": variant === "PDPSelectUpholsteryUI--quickview"
    })} key={id}><MaterialThumbnailPlaceholder /></div>);
    $[7] = variant;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t6 || $[10] !== t8) {
    t9 = <div className={t6}>{t8}</div>;
    $[9] = t6;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t4 || $[13] !== t9) {
    t10 = <div className={t4} data-xc="MaterialThumbnailGroup">{t9}</div>;
    $[12] = t4;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
};
export default memo(MaterialThumbnailGroupPlaceholder);